import PropTypes from 'prop-types';
import React from 'react';

export default function staticMap() {
  let StaticMap = props => {
    const style = {
      width: props.width,
      height: props.height,
      backgroundColor: '#eee'
    };

    return <div style={style}/>;
  };

  StaticMap.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number
  };

  /* eslint-disable no-undef */
  if (typeof google !== 'undefined') {
    // Make sure google maps scripts is already loaded,
    // Not really necessary validation on the client side, but
    // more to avoid using it on the server side
    StaticMap = require('@wix/restaurants-components/dist/web/StaticMap/StaticMap').default;
  }

  return StaticMap;
}



// WEBPACK FOOTER //
// ./components/StaticMap/StaticMap.js